var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBulletPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.638 0.024003C10.476 2.26848 7.30886 5.11168 5.04113 8.94005C4.21542 7.73024 2.16394 6.55279 0.289399 6.32339C0.102633 6.30055 0.00728363 6.53375 0.159646 6.64036C1.88379 7.84922 3.41331 10.1632 4.87795 13.31C4.94184 13.448 5.14237 13.449 5.20823 13.3119C7.63619 8.25186 10.9026 3.57824 14.8444 0.311464C15.0115 0.173445 14.8296 -0.0787976 14.638 0.024003Z",
    fill: "#FFA463"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBulletPoint);
export default __webpack_public_path__ + "static/media/custom-bullet-point.b59f04ac595f2240a818a748cd13d814.svg";
export { ForwardRef as ReactComponent };